import React, { useState, useEffect } from 'react';
import DataTable from 'react-data-table-component';
import { Link } from 'react-router-dom';
import { Row, Col, Button, DropdownButton, Dropdown, ButtonGroup,Form,Container} from 'react-bootstrap';
/*import * as XLSX from "xlsx/xlsx.mjs";*/
import * as XLSX from "@e965/xlsx/xlsx.mjs";
import { TableFilter } from '../components/TableFilter';
import CommonUtils from '../utils/siteUtils.js';
import RequestUtils from '../utils/requestUtils';
import '../styles/Vendor.css';
import { VendorSetIDDropdown } from '../components/VendorSetIDDropdown.js';

const RequestWorklist = (props) => {   
    const [worklistItems, setWorklistItems] = useState([]);
    const [resetPaginationToggle, setResetPaginationToggle] = React.useState(false);
    const [filterText, setFilterText] = React.useState(props.filterText);
    const [sortObj, setSortObj] = React.useState(JSON.parse(props.sortText));
    const [tableColumns, setTableColumns] = React.useState([]);
    const [hideRequests, setHideRequests] = React.useState(!(props.showAllResults === true));
    const [isLoading, setIsLoading] = useState(true); 
    const [selectedVendorSetID, setSelectedVendorSetID] = useState(() => {
        const savedVendorSetID = sessionStorage.getItem("selectedVendorSetID");
        return savedVendorSetID || 'UHGID';
    });

    const handleVendorSetIDChange = (newVendorSetID) => {
        setSelectedVendorSetID(newVendorSetID);
        sessionStorage.setItem("selectedVendorSetID", newVendorSetID);
    };
  
    const filteredItems = Array.isArray(worklistItems) && worklistItems.length > 0 && worklistItems[0].isSuccessful === true
        ? worklistItems.filter(row => {
            if (
                row.vendorRecord && row.vendorRecord.name &&
                row.vendorRecord.vendorSetId
            ) {
                const vendorSetIdMatch = row.vendorRecord.vendorSetId.toLowerCase().includes(selectedVendorSetID.toLowerCase());
                const searchTextMatch =
                    (row.vendorRecord.name && row.vendorRecord.name.toLowerCase().includes(filterText.toLowerCase())) ||
                    (row.requestor && row.requestor.email && row.requestor.email.toLowerCase().includes(filterText.toLowerCase())) ||
                    (row.requestor && row.requestor.firstName && row.requestor.firstName.toLowerCase().includes(filterText.toLowerCase())) ||
                    (row.requestor && row.requestor.lastName && row.requestor.lastName.toLowerCase().includes(filterText.toLowerCase())) ||
                    (row.vendorRecord.vendorId && row.vendorRecord.vendorId.toLowerCase().includes(filterText.toLowerCase())) ||
                    (row.bankRequest && row.bankRequest.paymentMethod && row.bankRequest.paymentMethod.toLowerCase().includes(filterText.toLowerCase())); //US9826452 filter by paymentmethod

                return vendorSetIdMatch && searchTextMatch;
            }
            return false;
        })
        : [];


    useEffect(() => {

        const columns = [
            {
                id: 'requestId',
                name: <span className='dtHeaderCell' title='Request ID'>Request ID</span>,
                selector: row => row.bankRequest.vendorBankRequestId,
                sortable: true,
                wrap: false,
                cell: row => <>{(row.bankRequest.vendorBankRequestId) ? row.bankRequest.vendorBankRequestId : ' '}</>,
                maxWidth: "6%",
                minWidth:"6%"
            },
            {
                id: 'supplierSetId',
                name: <span className='dtHeaderCell' title='Supplier Set ID'>Supplier Set ID</span>,
                selector: row => row.vendorRecord.vendorSetId,
                sortable: false,
                wrap: false,
                cell: row => <>{(row.vendorRecord.vendorSetId) ? row.vendorRecord.vendorSetId : ' '}</>,
                maxWidth: "6%",
                minWidth:"6%"
            },
            {
                //US9826452 payment method new column
                id: 'paymentMethod',
                name: <span className='dtHeaderCell' title='Payment Method' >Payment Method</span>,
                selector: row => row.bankRequest.paymentMethod,
                sortable: true,
                wrap: false,
                cell: row => <>{(row.bankRequest.paymentMethod) ? row.bankRequest.paymentMethod : ' '}</>,
                maxWidth: "6%",
                minWidth: "6%"
                
            },
            {
                id: 'supplierId',
                name: <span className='dtHeaderCell' title='Supplier ID'>Supplier ID</span>,
                selector: row => row.vendorRecord.vendorId,
                sortable: true,
                wrap: false,
                cell: row => <>{(row.vendorRecord.vendorId) ? row.vendorRecord.vendorId : ' '}</>,
                maxWidth: "7.5%",
                minWidth:"7.5%"
            },
            {
                id: 'supplierName',
                name: <span className='dtHeaderCell' title='Supplier Name'>Supplier Name</span>,
                selector: row => row.vendorRecord.name,
                sortable: true,
                wrap: false,
                cell: row => <>{(row.vendorRecord.name) ? row.vendorRecord.name : ' '}</>,
                maxWidth: "10%",
                minWidth:"10%"
            },
            {
                id: 'requestorLastName',
                name: <span className='dtHeaderCell' title='Requestor Last Name'>Requestor Last Name</span>,
                selector: row => row.requestor.lastName,
                wrap: false,
                cell: row => <>{(row.requestor.lastName) ? row.requestor.lastName : ' '}</>,
                minWidth: "8.5%",
                maxWidth: "8.5%"
            },
            {
                id: 'requestorFirstName',
                name: <span className='dtHeaderCell' title='Requestor First Name'>Requestor First Name</span>,
                selector: row => row.requestor.firstName,
                wrap: false,
                cell: row => <>{(row.requestor.firstName) ? row.requestor.firstName : ' '}</>,
                minWidth: "8.5%",
                maxWidth: "8.5%"
            },
            {
                id: 'requestorEmail',
                name: <span className='dtHeaderCell' title='Requestor Email'>Requestor Email</span>,
                selector: row => row.requestor.email,
                wrap: false,
                cell: row => <>{(row.requestor.email) ? row.requestor.email : ' '}</>,
                minWidth: "12%",
                maxWidth:"12%"
            },
            {
                id: 'requestTypeId',
                name: <span className='dtHeaderCell' title='Request Type'>Request Type</span>,
                selector: row => row.bankRequest.requestTypeId,
                wrap: false,
                sortable: true,
                cell: row => <>{(row.bankRequest.requestTypeId) ? RequestUtils.determineRequestType(row.bankRequest.requestTypeId) : ' '}</>,
                maxWidth: "6%",
            },
            {
                id: 'createdDt',
                name: <span className='dtHeaderCell' title='Submitted Date'>Submitted Date</span>,
                selector: row => row.bankRequest.createdDt,
                wrap: false,
                sortable: true,
                cell: row => <>{(row.bankRequest.createdDt) ? CommonUtils.renderStatusDate(row.bankRequest.createdDt) : ' '}</>,
                maxWidth: "9%"
            },
            {
                id: 'requestStatus',
                name: <span className='dtHeaderCell' title='Request Status'>Request Status</span>,
                sortable: true,
                selector: row => row.bankRequest.requestStatusId,
                cell: row => <>{(row.bankRequest.requestStatusId) ? RequestUtils.determineRequestStatus(row.bankRequest.requestStatusId) : ' '}</>,
                maxWidth: "7.5%",
                minWidth:"7.5%"
            },
            //{ Removed
            //    id: 'statusDate',
            //    name: <span className='dtHeaderCell' title='Status Date'>Status Date</span>,
            //    selector: row => row.bankRequest.updatedDt,
            //    wrap: false,
            //    cell: row => <>{(row.bankRequest.updatedDt) ? CommonUtils.renderStatusDate(row.bankRequest.updatedDt) : ' '}</>,
            //    maxWidth: "9%"
            //},
            {
                id: 'earlyWarning',
                name: <span className='dtHeaderCell' title='Early Warning Score'>Early Warning</span>,
                sortable: true,
                selector: row => row.bankRequest.earlyWarningScore,
                cell: row => {
                    let score = "BAD";
                    if (row.bankRequest) {
                        const { mostRecentCall } = RequestUtils.getMostRecentEarlyWarningScoreAndCall(row.bankRequest);

                        score = (mostRecentCall?.earlyWarningScore !== null && mostRecentCall?.earlyWarningScore !== undefined && mostRecentCall?.earlyWarningScore !== "")
                            ? (mostRecentCall.earlyWarningScore === -2 ? "N/A" : mostRecentCall.earlyWarningScore)
                            : "BAD";
                    }
                    let color = RequestUtils.getColor(score);
                    return <span style={{ color: color }}>{score !== null && score !== undefined ? score : ' '}</span>;
                },
                maxWidth: "7%",
                minWidth:"7%"
            },
            {
                id: 'btnArea',
                right: "true",
                cell: row => {
                    var path = `/Worklist/Request/${row.bankRequest.vendorBankRequestId}`;
                    return (<>
                        {(row.notifications.length > 0)
                            ? <>
                                <span className="requestNotificationAlert" title="New Request Action">!</span>
                            </>
                            : <></>}
                        <Link to={path} title="View Request">
                            <Button title="View Request Details" className="vContactBtn right">View Details</Button>
                        </Link>

                    </>);
                },

            }
        ];
        if (JSON.stringify(props.vendorData) !== JSON.stringify(worklistItems)) {
            setWorklistItems(sortData(props.vendorData, sortObj));
           
            if (!props.hasAdminAccess) {
                //Default Vendort SetID to current supplier SetID
                setSelectedVendorSetID(props.vendorData[0].vendorRecord.vendorSetId);
            }
        }
        else {
            setWorklistItems(sortData(worklistItems, sortObj));
        }
            var filteredCol = [];
            for (var i = 0; i < columns.length; i++) {
                if (columns[i].id) {
                    if (columns[i].id === 'earlyWarning') {
                        if (props.hasAdminAccess) {
                            filteredCol.push(columns[i]);
                        }
                    }
                    else { filteredCol.push(columns[i]); }
                }
            }

            setTableColumns(filteredCol)
    
            setWorklistItems(sortData(props.vendorData, sortObj)); 
       // }
    }, [sortObj, props, worklistItems]);

    // 	US6782947: Column Sort
    // Reworked this function to use generic sorting functions that can handle different data types. Cleaner for the amount of columns we are now allowing to be sorted.
    const sortData = (items, sortObj) => {  
        // Helper function to safely parse integers or return zero  
        const safeParseInt = (value) => (isNaN(parseInt(value)) ? 0 : parseInt(value));  
      
        // Generic string comparison function
        const stringCompare = (a, b) => a.localeCompare(b, undefined, { sensitivity: 'base' });  
      
        // Generic function to handle sorting by number 
        const numberCompare = (a, b, isAscending) => isAscending ? a - b : b - a;  
      
        // Function to get the value for the specified column.  
        const getColumnValue = (row, column) => {  
            switch (column) {  
                case 'requestId':  
                    return safeParseInt(row.bankRequest.vendorBankRequestId);
                case 'supplierSetId':
                    return row.bankRequest.vendorSetId;
                case 'paymentMethod':
                    return row.bankRequest.paymentMethod || '';
                case 'supplierId':  
                    return row.vendorRecord.vendorId;  
                case 'createdDt':  
                    return new Date(row.bankRequest.createdDt);  
                case 'requestTypeId':  
                    return RequestUtils.determineRequestType(row.bankRequest.requestTypeId);
                case 'supplierName':  
                    return row.vendorRecord.name;  
                case 'requestStatus':  
                    return RequestUtils.determineRequestStatus(row.bankRequest.requestStatusId);  
                case 'earlyWarning':  
                    return safeParseInt(row.bankRequest.earlyWarningScore);  
                default:  
                    return null;  
            }  
        };  
      
        // Determine the sort direction. 
        const isAscending = sortObj.dir === true;  
      
        // Sort the items according to the specified column and direction  
        return items.sort((a, b) => {  
            const valueA = getColumnValue(a, sortObj.col);  
            const valueB = getColumnValue(b, sortObj.col);  
      
            if (sortObj.col === 'supplierName' || sortObj.col === 'requestTypeId' || sortObj.col === 'paymentMethod') {  
                // String comparison  
                return stringCompare(valueA, valueB) * (isAscending ? 1 : -1);  
            } else if (sortObj.col === 'requestId' || sortObj.col === 'earlyWarning') {  
                // Numeric comparison 
                return numberCompare(valueA, valueB, isAscending);  
            } else if (sortObj.col === 'createdDt') {  
                // Date comparison
                return (valueA - valueB) * (isAscending ? 1 : -1);  
            } else {  
                // Default to string comparison for any other column types 
                return stringCompare(String(valueA), String(valueB)) * (isAscending ? 1 : -1);  
            }  
        });  
    };  
      
    const prepForExport = (itemsToExport) => {
        //Remove fields
        var exportItems = [];
        
        for (var i = 0; i < itemsToExport.length; i++) {
            var item = itemsToExport[i];
            var trimItem = {};
            for (var x = 0; x < tableColumns.length; x++) {
                var col = tableColumns[x];
                if (col.name) {
                    var colName = col.name.props.children;
                    var colId = col["id"];
                    var adVal = "";
                    switch (colId.toLowerCase()) {
                        case "requestid":
                            adVal = item.bankRequest.vendorBankRequestId;
                            break;
                        case "suppliersetid":
                            adVal = item.vendorRecord.vendorSetId;
                            break;
                        case "paymentmethod":
                            adVal = (item.bankRequest.paymentMethod) ? item.bankRequest.paymentMethod : ' ';
                            break;
                        case "supplierid":
                            adVal = item.vendorRecord.vendorId;
                            break;
                        case "suppliername":
                            adVal = item.vendorRecord.name;
                            break;
                        case "requestorlastname":
                            adVal = (item.requestor.lastName) ? item.requestor.lastName : ' ';
                            break;
                        case "requestorfirstname":
                            adVal = (item.requestor.firstName) ? item.requestor.firstName : ' ';
                            break;
                        case "requestoremail":
                            adVal = (item.requestor.email) ? item.requestor.email : ' ';
                            break;
                        case "requesttypeid":
                            adVal = (item.bankRequest.requestTypeId) ? RequestUtils.determineRequestType(item.bankRequest.requestTypeId) : ' ';
                            break;
                        case "createddt":
                            adVal = (item.bankRequest.createdDt) ? CommonUtils.renderStatusDate(item.bankRequest.createdDt) : ' ';
                            break;
                        case "earlywarning":
                            adVal = (item.bankRequest.earlyWarningScore !=='undefined' && item.bankRequest.earlyWarningScore.toString().length>0) ? (item.bankRequest.earlyWarningScore === -2) ? 'N/A' : item.bankRequest.earlyWarningScore.toString() : ' ';
                            break;
                        case "requeststatus":
                            adVal = (item.bankRequest.requestStatusId) ? RequestUtils.determineRequestStatus(item.bankRequest.requestStatusId) : ' ';
                            break;
                            //Removed
                        //case "statusdate":
                        //    adVal = (item.bankRequest.updatedDt) ? CommonUtils.renderStatusDate(item.bankRequest.updatedDt) : ' ';
                        //    break;
                        default:
                            break;
                    }
                    trimItem[colName] = adVal;
                }
            }
            exportItems.push(trimItem);            
        }
        return exportItems;
    }
    const exportExcelResults = () => {
        //Export to XLSX
        var dateStr = CommonUtils.formatDate();
        var curSupp = sessionStorage.getItem("curSupName");
        curSupp = (curSupp) ? curSupp : "Supplier";
        var fileTitle = `UHG_PSSP_Worklist_Export`;
        var fileName = `${dateStr}_UHG_PSSP_${curSupp}_Worklist.xlsx`;
        var exportItems = prepForExport(filteredItems);
        const ws = XLSX.utils.json_to_sheet(exportItems);
        var colArr = getExportColumns();
        //Export
        XLSX.utils.sheet_add_aoa(ws, colArr, { origin: "A1" });
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, fileTitle);
        XLSX.writeFile(wb, fileName);
    }
    const getExportColumns = () => {
        //update column names
        var colArr = [];
        // eslint-disable-next-line array-callback-return
        var result = tableColumns.map(item => {
            const obj = {};
            if (item.name) {
                obj["name"] = item.name.props.children;
                return obj["name"];
            }
        })

        colArr.push(result);
        return colArr;
    }
    const exportCSVResults = () => {
        //Export to CSV
        var dateStr = CommonUtils.formatDate();
        var curSupp = sessionStorage.getItem("curSupName");
        curSupp = (curSupp) ? curSupp : "Supplier";
        var fileTitle = `UHG_PSSP_Worklist_Export`;
        var fileName = `${dateStr}_UHG_PSSP_${curSupp}_Worklist.csv`;     
        
        //create sheet
        var exportItems = prepForExport(filteredItems);
        const ws = XLSX.utils.json_to_sheet(exportItems);
        var colArr = getExportColumns();
        //Export
        XLSX.utils.sheet_add_aoa(ws, colArr, { origin: "A1" });
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, fileTitle);
        XLSX.writeFile(wb, fileName, { outputType: "string", bookType: "csv" });
    }   
 
    const customStyles = {
        // search results DataTable custom styles
        table: {
            style: {
                // table styles
                padding: '0',
                margin: '0'
            },
        },
        headCells: {
            style: {
                // header styles
                fontSize: '14px',
                justifyContent: 'left !important',
                color: 'white',
                paddingLeft: '1%',
                borderRight: '1px solid white',
                fontWeight: '400',
                
            },
        },
        head: {
            style: {
                // head styles - so calendars go over
                zIndex: '99'
            },
        },
        headRow: {
            style: {
                // header styles
                backgroundColor: '#003C71',
            },
        },
    };
    const onShowClosed = () => {
        sessionStorage.setItem("reqShAllResults", !(props.showAllResults === true));
        props.onWorklistChange(true, !(props.showAllResults === true));
        setHideRequests(!hideRequests);
    }
    const buildHideRequests = () => {
     
        return ((props.hasAdminAccess)
            ? <div className="hideRequestToggleArea">
                <span className="hideRequestToggleText">Hide Closed Requests </span>
                <Form.Group as="div" controlId="hideRequests">
                    <Form.Switch
                    type="switch"
                    id="hideRequests"
                        checked={hideRequests}
                    onChange={onShowClosed}
                    />
                </Form.Group>
                </div>
        : <></>);
    }

    const onFilter = (searchText) => {
        sessionStorage.setItem("wlFltrTxt", searchText);
            setFilterText(searchText);
            setResetPaginationToggle(!resetPaginationToggle);
    }
    const onFilterClear = () => {
        sessionStorage.setItem("wlFltrTxt", "");
        setFilterText('');
    }

    const onResultsPageChange = (newPerPage, page) => {
        sessionStorage.setItem("wlRowCt", newPerPage);
        props.onWorklistChange(props.hasAdminAccess, props.showAllResults);
    }
    const onTableSort = (column, direction) => {
        console.log(`Changing Sort col to ${column.id }  and Order to: ${direction}`);
        var sortStr = `{"col":"${column.id}","dir":${(direction === "asc")}}`;
        sessionStorage.setItem("wlSort", sortStr);
        var sortObj = JSON.parse(sortStr);
        setSortObj(sortObj);
        setWorklistItems(sortData(worklistItems, sortObj));
    }

    const handleListLoaded = (isLoaded) => {
        setIsLoading(isLoaded);
    };

    const handleVendorSetIDDisplay = () => {
        return ((props.hasAdminAccess)
            ? <Col xs={2}>
                <VendorSetIDDropdown
                    currentAudience={selectedVendorSetID}
                    onChange={handleVendorSetIDChange}
                    onListLoaded={handleListLoaded}
                    showGlobalOption={false}
                    showAdminOption={false}
                    //selectedVendorSetID={false}
                    showLabel={false}
                />
            </Col>
            : <Col xs={2}>&nbsp;</Col>
        );
    };

    return (
        <Container fluid>
            <Row className="access-headers">
                <Col xs={12}><h3>Worklist</h3></Col>   
             </Row>
                  <Row id="resultsRow">
                    <Col xs={2}>
                    <TableFilter onFilter={onFilter} onFilterClear={onFilterClear} label="Search for request" filterText={ filterText} />
                </Col>
                {handleVendorSetIDDisplay()}
                <Col xs={2}>
                    {buildHideRequests()}
                </Col>
                    <Col xs={{ span: 1, offset: 3 }}>
                    <div className="searchResultsCountPill"><span className="searchResultsPill"> {filteredItems.length}</span> Results</div>
                    </Col>         
                     <Col xs={2}>
                    <ButtonGroup className="exportButtonGrp" style={{ padding: 0, float: "right" }}>
                            <DropdownButton
                                title="Export Results"
                                id="bg-nested-dropdown">
                                <Dropdown.Item eventKey="1" onClick={() => exportCSVResults()}>CSV</Dropdown.Item>
                                <Dropdown.Item eventKey="2" onClick={() => exportExcelResults()}>Excel</Dropdown.Item>
                            </DropdownButton>
                        </ButtonGroup>
                    </Col> 
            </Row>
            <Row>
                <Col xs={12} id="searchResults">                  
                    <DataTable
                        keyField="requestId"
                        columns={tableColumns}
                        data={filteredItems}                
                        fixedHeader
                        striped
                        responsive     
                        pagination
                        onChangeRowsPerPage={onResultsPageChange}
                        paginationPerPage={props.resultsPageCount}
                        paginationRowsPerPageOptions={[25, 50, 100]} 
                        customStyles={customStyles}  
                        onSort={onTableSort}
                        sortServer
                        defaultSortFieldId={sortObj.col}
                        defaultSortAsc={sortObj.dir}
                        />
                </Col>
            </Row>
        </Container>
        )
}
export default RequestWorklist



